<template>
  <div class="topbar-container">
    <div class="topbar">
      <div class="flex flex-center justify-between">
        <div class="logo">
          <img v-if="logo" :src="logo" />
        </div>
        <div class="flex1">
          <div class="store-name">{{ title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    storeData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      logo: '',
      title: ''
    }
  },
  components: {
  },
  created() {
    // console.log('this.$route.meta.title >> ', this.$route.meta.title)
    this.$route.meta.title = 'testaxxxxxxxxxxxxx'
    this.init()
  },
  methods: {
    init() {
      console.log('this.storeData >>> ', this.storeData);
      this.logo = this.storeData.logo
      this.title = this.storeData.chainstore_name || ''
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.topbar-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: #ee2d24;
  color: white;
  box-shadow: 0px -15px 10px 10px rgba(146, 146, 146, 0.85),
    -10px 10px 10px 10px rgba(255, 255, 255, 0.5);
  .topbar {
    padding: 0 10px;
    position: relative;
  }
  .logo {
    flex-basis: 50px;
    margin-right: 13px;
    position: absolute;
    top: 4px;
    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
      border: 1px solid #eeeeee;
      border-radius: 5px;
    }
  }
  .store-name {
    font-weight: bolder;
    font-size: 18px;
    height: 50px;
    line-height: 50px;
  }
}
</style>